var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useRef } from "react";
import { RicosNodeContextProvider } from "./../../ricos-context";
import { CELL_AUTO_MIN_WIDTH } from "../consts";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/table-viewer.scss";
function normalizeColumnWidths(colsMinWidths, colsRelativeWidths) {
  const colsWithDefaults = colsRelativeWidths.map((originalWidth, i) => {
    const minWidth = colsMinWidths[i] || CELL_AUTO_MIN_WIDTH;
    const width = originalWidth < minWidth ? minWidth : originalWidth;
    return {
      width,
      minWidth
    };
  });
  const ratios = colsWithDefaults.map((c) => c.width / c.minWidth);
  const smallestRatio = Math.min(...ratios);
  return colsWithDefaults.map(({ minWidth, width }) => ({
    minWidth,
    width: width / smallestRatio
  }));
}
const Table = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  var _a;
  const tableRef = useRef(null);
  const { dimensions: { colsMinWidth = [], colsWidthRatio = [] } = {} } = node.tableData || {};
  const colStyles = normalizeColumnWidths(colsMinWidth, colsWidthRatio);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, withHorizontalScroll: true }, /* @__PURE__ */ React.createElement("div", { ref: tableRef, className: styles.viewMode }, /* @__PURE__ */ React.createElement("table", { className: styles.container, "data-hook": ROOT }, /* @__PURE__ */ React.createElement("colgroup", null, colStyles.map((colStyle, index) => {
    return /* @__PURE__ */ React.createElement("col", { key: index, style: colStyle });
  })), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_a = node.nodes) != null ? _a : [] }))))));
};
const TableRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Table, __spreadValues({ key: node.id, node }, props));
};
var table_default = TableRenderer;
export {
  table_default as default
};
//# sourceMappingURL=table.js.map

import "@wix/ricos/css/plugin-table-viewer.global.css";